import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-function",
  "use": "icon-function-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-function\"><defs><style type=\"text/css\"></style></defs><path d=\"M829.376 629.76L760.32 497.536l61.568-59.136 2.368-2.56H1024v35.712l-37.76 101.376h-99.968l-56.96 56.832z m-174.848 174.464l-54.848 54.784-17.024 0.448H396.864v-38.784l36.672-98.368h92.928l56.832-54.656 71.232 136.576zM0 859.52v-41.92L256.512 129.28 699.52 128v41.856l-35.52 95.296h-296.32l-64.64 173.696h372.608l147.84 283.456h116.288v34.944l-38.08 102.208h-161.6l-3.392-1.472L589.632 576H251.904l-105.6 283.456H0z\" p-id=\"1950\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/function.svg
// module id = tNxQ
// module chunks = 26